export default '__THEMING__';


//////////////////
// WEBPACK FOOTER
// ./~/theming/dist/esm/channel.js
// module id = 46
// module chunks = 0